import * as navigation from 'Navigation';

export default class AgentFoundryTabState extends navigation.TabState {
  override defaults(): navigation.TabStateDefaults {
    return {
      ...super.defaults(),
      title: 'Foundry',
      closeable: false,
      preferenceKey: 'agent-foundry',
    };
  }
}
